import { useEffect, useState } from 'react';
import { useFocusWithin } from '@react-aria/interactions';
import { mergeProps } from '@react-aria/utils';
import runValidator from './runValidator';
import { VALIDATION_STATES } from '../../utils/constants';
const noop = () => undefined;
const defaultValidators = [];
export function useValidator(_ref) {
  let {
    value,
    onValidate = noop,
    validators = defaultValidators
  } = _ref;
  const [isTouched, setIsTouched] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const isValid = errorMessages.length === 0;
  useEffect(() => {
    (async () => {
      const results = await Promise.all(validators.map(validator => runValidator(validator, value)));
      setErrorMessages(results.filter(result => !result.valid).map(result => result.message));
    })();
  }, [isTouched, value, validators]);
  useEffect(() => {
    onValidate({
      isValid,
      isTouched,
      errorMessages,
      visibleValidationState: getVisibleValidationState({
        isValid,
        isTouched
      })
    });
  }, [isValid, isTouched, errorMessages]);
  const {
    focusWithinProps
  } = useFocusWithin({
    onBlurWithin: () => {
      if (!isTouched) setIsTouched(true);
    }
  });
  return {
    isValid,
    isTouched,
    errorMessages,
    visibleValidationState: getVisibleValidationState({
      isValid,
      isTouched
    }),
    validatorProps: mergeProps(focusWithinProps)
  };
}
export function getVisibleValidationState(_ref2) {
  let {
    isValid,
    isTouched
  } = _ref2;
  if (!isTouched) {
    return VALIDATION_STATES.neutral;
  }
  return isValid ? VALIDATION_STATES.success : VALIDATION_STATES.error;
}